import initFocalPoint from './init-focal-point';

export default {
  initFocalPoint,
};
